/**
 * Tipo de servicio y helpers de carrito (delivery).
 */

export const TIPOS_SERVICIO_OPTS = {
	comer: { label: 'LOCAL', color: '#4CAF50', border: '#388E3C' },
	llevar: { label: 'PARA LLEVAR', color: '#2196F3', border: '#1976D2' },
	delivery: { label: 'DELIVERY', color: '#9C27B0', border: '#7B1FA2' },
};

export function attachCartServiceGlobals(win, $) {
	win.TIPOS_SERVICIO_OPTS = TIPOS_SERVICIO_OPTS;
	win.modoServicioSeleccionado = win.modoServicioSeleccionado || 'comer';
	win.carrito = win.carrito || [];

	win.getTipoServicioLabel = (tipo) => (TIPOS_SERVICIO_OPTS[tipo] || TIPOS_SERVICIO_OPTS.comer).label;

	win.seleccionarTipoServicio = (tipo) => {
		if (!TIPOS_SERVICIO_OPTS[tipo]) tipo = 'comer';
		win.modoServicioSeleccionado = tipo;
		$('.btn-tipo-servicio').each(function () {
			const t = $(this).data('tipo');
			const active = t === tipo;
			const cfg = TIPOS_SERVICIO_OPTS[t] || TIPOS_SERVICIO_OPTS.comer;
			$(this).css({
				background: active ? cfg.color : '#fff',
				color: active ? '#fff' : cfg.color,
				border: `2px solid ${active ? cfg.border : cfg.color}`,
			});
		});
		win.actualizarDeliveryFeeUI();
		if (typeof win.actualizarCarrito === 'function') win.actualizarCarrito();
	};

	win.getDeliveryFeeUsd = () => {
		if (win.modoServicioSeleccionado !== 'delivery') return 0;
		return Math.max(0, parseFloat($('#delivery-fee-input').val()) || 0);
	};

	win.posknRepartidoresActivos = win.posknRepartidoresActivos || [];

	win.getRepartidorPedido = () => {
		if (win.modoServicioSeleccionado !== 'delivery') return null;
		const $sel = $('#poskn-repartidor-select');
		const id = parseInt($sel.val(), 10) || 0;
		if (!id) return null;
		const opt = $sel.find('option:selected');
		return {
			id,
			nombre: String(opt.data('nombre') || opt.text() || ''),
			telefono: String(opt.data('telefono') || ''),
		};
	};

	win.requireRepartidorSiDelivery = () => {
		if (win.modoServicioSeleccionado !== 'delivery') return true;
		if (!(win.posknRepartidoresActivos || []).length) return true;
		if (win.getRepartidorPedido()) return true;
		if (typeof win.mostrarNotificacion === 'function') {
			win.mostrarNotificacion('Selecciona un repartidor para el delivery', 'error');
		}
		return false;
	};

	win.cargarRepartidoresActivos = () => {
		const url =
			win.ajaxurl ||
			(win.POSKN_API_CONFIG && win.POSKN_API_CONFIG.ajaxUrl) ||
			'pos-ajax.php';
		const nonce = win.posNonce || (win.POSKN_API_CONFIG && win.POSKN_API_CONFIG.posNonce) || '';
		$.ajax({
			url,
			type: 'POST',
			dataType: 'json',
			data: { action: 'poskn_get_repartidores_activos', nonce },
			success(res) {
				const list = res && res.success && res.data ? res.data.repartidores || [] : [];
				win.posknRepartidoresActivos = list;
				const $sel = $('#poskn-repartidor-select');
				if (!$sel.length) return;
				const prev = $sel.val();
				$sel.find('option:not(:first)').remove();
				list.forEach((r) => {
					const $o = $('<option></option>')
						.val(r.id)
						.text(r.nombre)
						.attr('data-nombre', r.nombre)
						.attr('data-telefono', r.telefono || '');
					$sel.append($o);
				});
				const draft = win._posknRepartidorDraftId;
				if (prev && $sel.find(`option[value="${prev}"]`).length) {
					$sel.val(prev);
				} else if (draft && $sel.find(`option[value="${draft}"]`).length) {
					$sel.val(String(draft));
				}
			},
		});
	};

	win.actualizarDeliveryFeeUI = () => {
		const isDelivery = win.modoServicioSeleccionado === 'delivery';
		$('#delivery-fee-wrap').toggle(isDelivery);
		$('#poskn-repartidor-wrap').toggle(isDelivery);
		if (!isDelivery) {
			$('#delivery-fee-input').val('');
			$('#poskn-repartidor-select').val('');
		} else if (typeof win.cargarRepartidoresActivos === 'function') {
			win.cargarRepartidoresActivos();
		}
	};

	$(document).on('input change', '#delivery-fee-input', () => {
		if (typeof win.actualizarCarrito === 'function') win.actualizarCarrito();
		if ($('#modal-pago').is(':visible') && typeof win.sincronizarTotalesModalPagoDesdeCarrito === 'function') {
			win.sincronizarTotalesModalPagoDesdeCarrito();
		}
	});

	$(() => {
		if (typeof win.cargarRepartidoresActivos === 'function') {
			win.cargarRepartidoresActivos();
		}
		if (typeof win.seleccionarTipoServicio === 'function') {
			win.seleccionarTipoServicio(win.modoServicioSeleccionado || 'comer');
		}
	});
}
